import { STRIPE_PK } from '@/constants'
import { mapGetters } from 'vuex'
import { JSConn } from '../../utilities/js-conn.js'
import api from '@/api'
import { processMessages } from '@/api/messages'
import { getUserCompanyData } from '@/api/company-data'

export default {
  name: 'SubscriptionForm',
  data () {
    return {
      card: null,
      stripe: null,
      isLoading: false
    }
  },
  mounted: function () {
    // Create a Stripe client.
    this.stripe = Stripe(STRIPE_PK)

    // Create an instance of Elements.
    const elements = this.stripe.elements()

    // Custom styling can be passed to options when creating an Element.
    const style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    // Create an instance of the card Element.
    this.card = elements.create('card', {style: style})

    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount('#card-element')

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {
      const displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })
  },

  computed: {
    ...mapGetters([
      'companyName',
      'userName',
      'emailAddress'
    ])
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()
      this.isLoading = true

      this.stripe.createToken(this.card).then((result) => {
        if (result.error) {
          // Inform the user if there was an error.
          const errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
        } else {
          // Send the token to your server.
          const customerParams = {
            company_subscription: {
              source: result.token['id']
            }
          }

          const jsConn = new JSConn()
          jsConn.formParams = customerParams
          jsConn.fromRoutePath = this.$router.currentRoute.path
          jsConn.toRoutePath = '/crops'
          api.createCompanySubscription(jsConn)
            .then(jsConn => {
              // api call was successful
              // need to route to the correct place
              // and store the necessary data
              if (jsConn.apiCallStatus === 'success') {
                // call was a success, but that doesn't mean
                // that the credit card was charged successfully
                // check that

                if (jsConn.response['data']['status'] === 'account issue') {
                  // show the user the message and wait for response
                  processMessages(jsConn)
                    .then(jsConn => {
                      this.isLoading = false
                    })
                } else {
                  // only if there is no account problem do we want to reroute
                  processMessages(jsConn)
                    .then(jsConn => {
                      // load the user data
                      return getUserCompanyData(jsConn)
                    })
                    .then(jsConn => {
                      this.$router.push(jsConn.toRoutePath)
                    })
                }
              }
            })
        }
      })
    }
  }
}
